import React from "react";
import videoCard from "../../assets/images/video-card.png";
import tutor from "../../assets/images/tutor.png";
import { Tutorial, PaginationData, PaginationProps } from "../pagination/types";
import { nanoid } from "nanoid";

const getTutorials = <T extends object>({
  limit,
  offset,
}: PaginationProps): PaginationData<T> => {
  let data = [];
  data = tutorialsData.slice(offset, limit + offset) as T[];
  return {
    pagination: { limit, offset, total: tutorialsData.length },
    data,
  };
};

export const getTutorial = (id: string | undefined) => {
  const tutorial = tutorialsData.filter((tutorial) => tutorial.id === id);
  return tutorial[0];
};
export default getTutorials;

export const getMyTutorials = <T extends object>({
  limit,
  offset,
}: PaginationProps): PaginationData<T> => {
  const myTutorials = tutorialsData.filter(
    (tutorial) => tutorial.tutor === "Hannah Tory"
  );
  let data = [];
  data = myTutorials.slice(offset, limit + offset) as T[];
  return {
    pagination: { limit, offset, total: myTutorials.length },
    data,
  };
};

export const getFavouriteTutorials = <T extends object>({
  limit,
  offset,
}: PaginationProps): PaginationData<T> => {
  const favouriteTutorials = tutorialsData.filter(
    (tutorial) => tutorial.favourite === true
  );
  console.log(favouriteTutorials);
  let data = [];
  data = favouriteTutorials.slice(offset, limit + offset) as T[];
  return {
    pagination: { limit, offset, total: favouriteTutorials.length },
    data,
  };
};

export const tutorialsData: Tutorial[] = [
  {
    id: nanoid(),
    videoLink:
      "https://media.thetavideoapi.com/video_qacktqxweujewygfbdv7bcjf0q/master.m3u8",
    videoCardImage: <img src={videoCard} alt="video card" width={"85%"} />,
    tutor: "Hannah Tory",
    tutorImage: <img src={tutor} alt="video card" />,
    rating: 3,
    price: 200,
    field: "Career Adviser",
    experience: "Professional",
    tutorialName: "The Ultimate Job Interview Preparation Guide",
  },
];
